import { render, staticRenderFns } from "./videomostSettings.vue?vue&type=template&id=eda6bfbc&scoped=true&lang=pug&"
import script from "./videomostSettings.vue?vue&type=script&lang=js&"
export * from "./videomostSettings.vue?vue&type=script&lang=js&"
import style0 from "./videomostSettings.vue?vue&type=style&index=0&id=eda6bfbc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda6bfbc",
  null
  
)

export default component.exports